module.exports = __webpack_public_path__ + "img/photo-11.3e1d17bf.jpg";